var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 32,
    viewBox: "0 0 181 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H9.04751C15.8514 0 21.0743 4.63459 21.0743 12.8733C21.0743 21.1121 15.8514 25.7467 9.04751 25.7467H0V0ZM9.04751 24.0914C14.5652 24.0914 19.0146 20.2668 19.0146 12.8733C19.0146 5.4799 14.564 1.69184 9.04751 1.6553H1.9123V24.0914H9.04751Z",
    fill: "#101828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7188 15.6333C23.7188 9.01332 28.0951 5.1875 33.5019 5.1875C38.9088 5.1875 43.2851 9.0121 43.2851 15.6333C43.2851 22.2545 38.9088 26.0791 33.5019 26.0791C28.0951 26.0791 23.7188 22.2545 23.7188 15.6333ZM41.3363 15.6333C41.3363 10.0426 37.9161 6.80626 33.5019 6.76972C29.0878 6.73318 25.6676 10.0426 25.6676 15.6333C25.6676 21.224 29.0878 24.5346 33.5019 24.4981C37.9161 24.4603 41.3363 21.224 41.3363 15.6333Z",
    fill: "#101828"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9766 15.5968C45.9766 9.45425 49.6172 5.1875 55.7598 5.1875C61.3505 5.1875 64.4029 8.8294 64.845 13.2423H62.8962C62.6392 9.78555 60.1373 6.7685 55.761 6.7685C50.9059 6.7685 47.9266 10.4104 47.9266 15.5955C47.9266 21.0754 51.3468 24.4969 55.761 24.4969C60.1751 24.4969 62.4918 21.1497 62.8962 18.4275H64.845C64.3298 22.4372 61.1666 26.0779 55.7598 26.0779C49.912 26.0779 45.9766 21.922 45.9766 15.5955V15.5968Z",
    fill: "#101828"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7164 18.5006C87.7164 23.0244 83.8918 25.7467 79.1829 25.7467H68.6641V0H78.742C82.5301 0 85.8772 2.39099 85.8772 6.58344C85.8772 9.23143 84.1854 11.1803 81.6848 11.9903C85.2158 12.6529 87.7164 14.933 87.7164 18.5006ZM70.5764 1.6553V11.3289H77.8955C81.4265 11.3289 83.8175 9.56395 83.8175 6.58465C83.8175 3.60536 81.5739 1.6553 78.2999 1.6553H70.5764ZM85.6568 18.5006C85.6568 15.0804 82.8614 12.983 78.6312 12.983H70.5764V24.0914H78.7786C82.714 24.0914 85.6568 21.7369 85.6568 18.5006Z",
    fill: "#101828"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.494 24.2046V25.749H108.097C106.221 25.749 105.081 24.6089 105.081 22.6589V20.3787C104.125 23.9829 100.998 26.1156 97.2464 26.1156C93.311 26.1156 90.5156 23.8355 90.5156 19.9366C90.5156 16.3324 92.8701 13.8318 97.8348 13.8318H100.483C103.683 13.8318 104.859 12.8757 104.859 11.073C104.859 8.38848 102.652 6.76972 99.4158 6.76972C95.9578 6.76972 93.5302 8.60894 93.2002 12.0657H91.2879C91.6557 7.65157 94.7458 5.1875 99.417 5.1875C104.088 5.1875 106.81 7.72587 106.81 11.4774V22.4384C106.81 23.5785 107.289 24.2033 108.355 24.2033H109.495L109.494 24.2046ZM104.97 13.207H104.933C104.418 14.6406 102.947 15.4506 100.299 15.4506H97.9078C93.8993 15.4506 92.501 17.7685 92.501 19.9378C92.501 22.2557 94.0089 24.4993 97.5034 24.4993C101.182 24.4993 104.97 22.0352 104.97 16.3337V13.207Z",
    fill: "#101828"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M126.118 5.51562L116.187 30.9687C115.93 31.5936 115.341 31.998 114.532 31.998H108.242V30.4535H114.494L116.774 24.6423L109.197 5.51684H111.22L117.694 22.5461L124.094 5.51684H126.117L126.118 5.51562Z",
    fill: "#101828"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M165.993 8.77645C165.993 10.8495 164.394 12.0249 162.354 12.0249H158.388V16.9056H157.539V5.48047H162.354C164.394 5.48047 165.993 6.70459 165.993 8.77767V8.77645ZM165.08 8.77645C165.08 7.2259 163.937 6.21372 162.175 6.21372H158.388V11.2892H162.175C163.937 11.2892 165.08 10.3428 165.08 8.77645Z",
    fill: "#101828"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M167.445 7.92863H168.228V9.85433H168.261C168.588 8.77759 169.404 7.78125 171.036 7.78125H172.13V8.49989H170.84C169.274 8.49989 168.261 9.65823 168.261 11.8446V16.9043H167.445V7.92741V7.92863Z",
    fill: "#101828"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M172.18 12.4171C172.18 9.47918 174.122 7.78125 176.521 7.78125C178.919 7.78125 180.862 9.47918 180.862 12.4171C180.862 15.3549 178.919 17.0517 176.521 17.0517C174.122 17.0517 172.18 15.3537 172.18 12.4171ZM179.998 12.4171C179.998 9.93594 178.481 8.49988 176.522 8.48283C174.563 8.467 173.046 9.93594 173.046 12.4171C173.046 14.8982 174.563 16.3671 176.522 16.3501C178.481 16.3342 179.998 14.897 179.998 12.4171Z",
    fill: "#101828"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M140.467 5.38281C134.799 5.38281 130.203 9.97843 130.203 15.6471C130.203 21.3158 134.799 25.9114 140.467 25.9114C146.136 25.9114 150.732 21.3158 150.732 15.6471C150.732 9.97843 146.136 5.38281 140.467 5.38281ZM146.419 17.0393H142.558C142.173 17.0393 141.86 17.3524 141.86 17.7373V21.5984H139.074V17.7373C139.074 17.3524 138.761 17.0393 138.376 17.0393H134.515V14.2537H138.376C138.761 14.2537 139.074 13.9407 139.074 13.5558V9.69463H141.86V13.5558C141.86 13.9407 142.171 14.2537 142.558 14.2537H146.419V17.0393Z",
    fill: "#00EAFE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M138.377 17.0395H134.516V14.2539C130.893 14.2539 130.633 18.5901 130.633 18.5901C132.755 25.2588 139.076 25.8166 139.076 25.8166V17.7375C139.076 17.3526 138.763 17.0395 138.378 17.0395H138.377Z",
    fill: "url(#paint0_linear_3628_71670)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M138.376 14.2546C138.761 14.2546 139.074 13.9416 139.074 13.5567V9.69557H141.86C141.86 6.07316 137.523 5.8125 137.523 5.8125C130.855 7.9343 130.297 14.2559 130.297 14.2559H138.376V14.2546Z",
    fill: "url(#paint1_linear_3628_71670)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M141.861 5.47656V9.69459V13.5557C141.861 13.9406 142.172 14.2537 142.559 14.2537H146.42V17.0393C150.042 17.0393 150.303 12.7031 150.303 12.7031C148.181 6.03442 141.859 5.47656 141.859 5.47656H141.861Z",
    fill: "url(#paint2_linear_3628_71670)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M146.415 17.0403H142.554C142.169 17.0403 141.856 17.3533 141.856 17.7382V21.5994H139.07C139.07 25.2218 143.406 25.4824 143.406 25.4824C150.075 23.3606 150.633 17.0391 150.633 17.0391H146.415V17.0403Z",
    fill: "url(#paint3_linear_3628_71670)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3628_71670",
    x1: 134.854,
    y1: 14.2539,
    x2: 134.854,
    y2: 25.8166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#00AFBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00C8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#00DAED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#00E6F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3628_71670",
    x1: 141.86,
    y1: 10.033,
    x2: 130.297,
    y2: 10.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#00AFBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00C8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#00DAED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#00E6F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3628_71670",
    x1: 146.082,
    y1: 17.0393,
    x2: 146.082,
    y2: 5.47656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#00AFBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00C8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#00DAED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#00E6F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3628_71670",
    x1: 139.07,
    y1: 21.262,
    x2: 150.633,
    y2: 21.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#00AFBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00C8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#00DAED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#00E6F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EAFE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.f52acfb12299e1ed3eb4a26ac31a19a5.svg";
export { ForwardRef as ReactComponent };